/*!
  Pioneer WFRIA FieldsetContext v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["FieldsetContext"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("FieldsetContext") < 0) {
    window.__PIONEER_GLOBAL__.components.push("FieldsetContext");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import React from "react";
export const FieldsetContext = /*#__PURE__*/React.createContext();